import { useEffect, useRef } from 'react';
import { supabase } from '@/lib/supabase/client';
import { useToast } from '@/components/ui/Toast';
/**
 * Affiche des toasts informatifs sur les événements d'auth (sign-in via lien
 * magique, confirmation d'email après upgrade depuis un compte anonyme).
 *
 * Volontairement silencieux sur INITIAL_SESSION (chargement de l'app) et
 * TOKEN_REFRESHED (refresh transparent) pour ne pas spammer.
 *
 * À monter une seule fois dans l'arbre, sous AuthProvider + ToastProvider.
 */
export function AuthEventListener() {
    const { toast } = useToast();
    const initialFired = useRef(false);
    useEffect(() => {
        const { data: sub } = supabase.auth.onAuthStateChange((event, session) => {
            if (event === 'INITIAL_SESSION') {
                initialFired.current = true;
                return;
            }
            // Si initial n'est pas encore passé, on est probablement en plein chargement.
            if (!initialFired.current)
                return;
            const email = session?.user?.email;
            const isAnon = !!session?.user?.is_anonymous;
            if (event === 'SIGNED_IN' && email && !isAnon) {
                toast({
                    tone: 'success',
                    title: 'Connexion réussie',
                    description: `Bienvenue, ${email}.`,
                });
            }
            else if (event === 'USER_UPDATED' && email && !isAnon) {
                toast({
                    tone: 'achievement',
                    title: 'Email confirmé !',
                    description: 'Ton compte est désormais permanent. Toute ta progression est sauvegardée.',
                });
            }
            else if (event === 'SIGNED_OUT') {
                toast({ title: 'Tu es déconnecté.' });
            }
        });
        return () => sub.subscription.unsubscribe();
    }, [toast]);
    return null;
}
